import React, { memo, useCallback, useMemo, useRef } from 'react';
import Chart from 'shards/ForceBI/components/Charts/Chart';
import { downloadImage } from '../../../hooks/dom-utils';
import BoxInfo from '../BoxInfo';

const areEqual = (prevProps, nextProps) => {
    return (
        prevProps.id === nextProps.id &&
        prevProps.loading === nextProps.loading &&
        prevProps.type === nextProps.type &&
        prevProps.data === nextProps.data
    );
};

const CopilotChart = memo(({ id, loading, type, data }) => {
    const chartImageRef = useRef(null);

    const boxInfoProps = useMemo(
        () => ({
            isChart: true,
            onDownload: () => downloadImage(chartImageRef.current, `chart_${id}.jpeg`),
            loading: loading || !data || !type,
        }),
        [loading, data, type, id],
    );

    const chartProps = useMemo(
        () => ({
            type,
            data,
            getImage: (ref) => {
                chartImageRef.current = ref;
            },
        }),
        [type, data],
    );

    return (
        <BoxInfo {...boxInfoProps}>
            <Chart {...chartProps} />
        </BoxInfo>
    );
}, areEqual);

export default CopilotChart;
